import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { PromptsCarouselProps } from "../../Services/CommonServices/propTypes";
import "./PromptsCarousel.scss";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";

function NextArrow({ onClick }) {
  return (
    <div className="nextAr-arrow d-none d-lg-block" onClick={onClick}>
      <img
        className="pt-1 pe-1 next-icon"
        src="/static/assets/NextArrow.svg"
        alt="next-arrow"
      />
    </div>
  );
}
 
NextArrow.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
};
 
function PrevArrow({ onClick }) {
  return (
    <div className="prevAr-arrow d-none d-lg-block" onClick={onClick}>
      <img
        className="pt-1 ps-1 prev-icon"
        src="/static/assets/PrevArrow.svg"
        alt="prev-arrow"
      />
    </div>
  );
}
 
PrevArrow.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
};

PrevArrow.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
};

function PromptsCarousel(props) {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(() => {
    return typeof window !== 'undefined' && window.innerWidth < 577;
  });
  const baseSettings = {
    className: "slider variable-width",
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };
  const [settings, setSettings] = useState(baseSettings);
  const cardData = [
    {
      "id": 4,
      "cardTitle": "THE BEST DRESSED BEAR IN THE WORLD",
      "cardDescription": "RL History",
      "thumbImageUrl": "./static/assets/thebestdressedbearintheworld4.jpg",
      "path": "/polar"
    },
    // {
    //   id: 1,
    //   thumbImageUrl: "./static/assets/seasideLook.jpg",
    //   cardTitle: "OUR FAVORITE SEASIDE LOOKS",
    //   cardDescription:
    //     "The Hamptons is many things, but to Ralph it’s a tapestry of inspiration...",
    //   path: "seaside",
    // },
    // {
    //   id: 2,
    //   thumbImageUrl: "./static/assets/thebestdressedbearintheworld4.jpg",
    //   cardTitle: "THE BEST DRESSED BEAR IN THE WORLD",
    //   cardDescription: "The inside story of the iconic Polo Bear",
    //   path: "polar",
    // },
    // {
    //   id: 3,
    //   thumbImageUrl: "./static/assets/abronxtale5.jpg",
    //   cardTitle: "A BRONX TALE",
    //   cardDescription:
    //     "How a small drawer full of wide ties led to an empire of American style.",
    //   path: "bronxtale",
    // },
    // {
    //   id: 4,
    //   thumbImageUrl: "./static/assets/theartofbuildingUp1.jpg",
    //   cardTitle: "THE ART OF BUNDLING UP",
    //   cardDescription:
    //     "Staying warm is a matter of technicality. Looking good while layered up...",
    //   path: "art",
    // },
    // {
    //   id: 5,
    //   thumbImageUrl: "./static/assets/coldComfort2.jpg",
    //   cardTitle: "COLD COMFORT",
    //   cardDescription:
    //     "There’s no time like a polar vortex to make sure you have a great winter coat that can be a class... ",
    //   path: "cold",
    // }
    // {
    //   id: 6,
    //   thumbImageUrl: "./static/assets/thebigfive3.png",
    //   cardTitle: "THE BIG FIVE",
    //   cardDescription:
    //     "Much like New York, Ralph Lauren’s hometown, these truly iconic pieces are timeless. ",
    //   path: "bigfive",
    // },
  ];

  const [cards, setCards] = useState(cardData);

  const getDynamicCards = async(bucketUrl, cardFolder) => {
    const response = await fetch(`${bucketUrl}Dynamic_Pages/${cardFolder}/cards.json`)
    if(response.ok){
      const data = await response.json();
      setCards(data.cards);
    }
    else {
      setCards([]);
    }
  }

  useEffect(() => {
    if (props.bucketUrl && props.cardFolder) {
      getDynamicCards(props.bucketUrl, props.cardFolder);
    }
  }, [props.bucketUrl, props.cardFolder]);

  useEffect(() => {
    const updateSettings = () => {
      const width = window.innerWidth;
      setIsMobile(width < 577); // Set mobile state
      
      if (width > 576 && width < 991) {
        setSettings({
          ...baseSettings,
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 0,
        });
      } else if (width < 577) {
        setSettings({
          ...baseSettings,
          slidesToShow: 1.35,
          slidesToScroll: 1,
          initialSlide: 0,
          centerMode: true,
          centerPadding: "16px",
        });
      } else {
        setSettings(baseSettings);
      }
    };
    window.addEventListener("resize", updateSettings);
    updateSettings();
    return () => {
      window.removeEventListener("resize", updateSettings);
    };
  }, []);

  // Hide the carousel if keyboard is open on mobile devices
  if (isMobile && props.isKeyboardOpen) {
    return null;
  }

  return (
    <div className="static-promts-carousel">
      <div className="prompts-carousel--mobile col-10 col-lg-11 col-xxl-10 mx-lg-auto">
        {/* <div className="prompts-carousel__header">
          <div className="prompts-carousel__subheading">GET INSPIRED</div>
        </div> */}

        <div className="prompts-carousel__title-container">
          <div className="prompts-carousel__title">Ralph's Style Guides</div>
          {/* <span className="prompts-carousel__pagination d-sm-none">  {currentSlide} | {cards?.length} </span> */}
        </div>
       
      </div>
      <div className="archive-container slider-container container-fluid px-0 col-12 col-md-11 col-xxl-10">
        <div className="px-0">
          <Slider {...settings}>
            {cards && cards.length > 0 && cards.map((card, i) => (
              <div
                style={{ position: "relative" }}
                key={`archive-card-${card.id}-${i}`}
              >
                <button
                  name="staticTemplates"
                  className="border-0 bg-transparent px-0 archive-width"
                  style={{ minWidth: "100%" }}
                >
                  <div className="d-grid">
                    <div
                      className="content-container"
                      style={{ position: "relative" }}
                      onClick={() => navigate(card.path)}
                    >
                      <div className="d-flex">
                        <div className="prompts-carousel__image-container">
                          <img
                            src={card.thumbImageUrl}
                            className="prompts-carousel__image"
                            alt={card.cardTitle}
                          />
                        </div>
                        <div className="prompts-carousel__content">
                          <span className="prompts-carousel__card-title">
                            {card.cardTitle}
                          </span>
                          <span className={`prompts-carousel__card-description ${i === 0 && 'seaside_lineclamp'}`}>
                            {card.cardDescription}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </button>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
}
 
PromptsCarousel.propTypes = PromptsCarouselProps;
 
export default PromptsCarousel;